import { render } from "./ContentField.vue?vue&type=template&id=5e8ea286&scoped=true"
const script = {}

import "./ContentField.vue?vue&type=style&index=0&id=5e8ea286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e8ea286"]])

export default __exports__